<h3>Uppsetningarleiðbeiningar</h3>
<p>
  Skilríkið ætti eingöngu að setja upp á einu tæki. Ekki senda lykilorð og
  skilríkjaskrá saman undir neinum kringumstæðum. Ekki geyma lykilorðið.
</p>
<app-expandable-section>
  <h4>Android</h4>
  <div slot="text">
    <p>
      <strong>Athugið</strong> að til að hægt sé að nota skilríki í símanum þarf
      hann að læsast þegar hann er ekki í notkun, t.a.m. með PIN eða mynstri.
    </p>
    <ol role="list">
      <li role="listitem">Finnið skrána í Downloads og smellið á hana.</li>
      <li role="listitem">
        Nú þarf að slá inn lykilorðið sem birtist á síðunni. Athugið að passa
        hástafi og lágstafi.
      </li>
      <li role="listitem">Veljið nafn á skilríkið svo þið þekkið það.</li>
      <li role="listitem">
        Smellið á OK og þá ætti skilríkið að vera tilbúið til notkunar. Eyðið
        skránni.
      </li>
    </ol>
  </div>
</app-expandable-section>
<app-expandable-section>
  <h4>iOS</h4>
  <div slot="text">
    <ol role="list">
      <p>
        Talað er um "Profile" í iOS fyrir þessi skilríki. Aðeins ein profile
        uppsetning getur verið virk í einu, og er aðeins virk í 8 mínútur.
      </p>
      <li role="listitem">
        Þegar skráin er sótt birtist gluggi, staðfesta þarf að leyft sé að sækja
        þennan profile.
      </li>
      <li role="listitem">
        Farið í Settings. Þar gæti verið tilkynning eins og "Profile Downloaded"
        sem hægt er fara inn í til að klára uppsetningu. Ef ekki þarf að fylgja
        næsta skrefi.
      </li>
      <li role="listitem">
        Fara þarf í Settings -> General -> Profiles & Device Management. Finnið
        þennan nýja profile.
      </li>
      <li role="listitem">
        Smellið á Install. Þá þarf að slá inn lykilorðið sem birtist á síðunni.
        Athugið að passa hástafi og lágstafi.
      </li>
      <li role="listitem">
        Að þessu loknu ætti skilríkið að vera tilbúið til notkunar.
      </li>
    </ol>
  </div>
</app-expandable-section>
<app-expandable-section>
  <h4>Windows</h4>
  <div slot="text">
    <ol role="list">
      <li role="listitem">
        Opnið skilríkjaskrána (eða hægri smellið og veljið "Install PFX"). Það
        ætti að birtast Certificate Import Wizard gluggi.
      </li>
      <li role="listitem">
        Store Location ætti að vera "Current User". Veljið next.
      </li>
      <li role="listitem">
        Nú birtist "File to Import", sem ætti nú þegar að vera skráin sem var
        opnuð. Veljið next.
      </li>
      <li role="listitem">
        Nú þarf að slá inn lykilorðið sem birtist á skjánum. Athugið að passa
        hástafi og lágstafi.
      </li>
      <li role="listitem">
        Eingöngu á að vera hakað í "Include all extended properties." Veljið
        next.
      </li>
      <li role="listitem">
        Veljið Certificate store með því að smella á "Place all certificates in
        the following store" og svo "Browse...". Það ætti að vera "Personal".
        Veljið next.
      </li>
      <li role="listitem">
        Veljið Finish og þá ætti skilríkið að vera tilbúið til notkunar. Eyðið
        skránni.
      </li>
    </ol>
  </div>
</app-expandable-section>

<p>
  Að lokinni uppsetningu er um að gera að prófa að opna síðuna
  <a href="https://u.112.is" target="_blank" mat-link-button>hér</a>.
</p>
<h3>Notkun</h3>
<p>
  Þegar síðan er opnuð býður vafrinn upp valmynd þar sem ætti að vera hægt að
  velja skilríkið til auðkenningar. Í tilfelli einhverra vafra er það sjálfvalið
  ef þetta er eina skilríkið sem kemur til greina.
</p>
<p>
  Yfirleitt geymir vafrinn valið á skilríkinu á meðan hann er opinn. Til að fá
  valmyndina aftur eða skipta um skilríki þarf því að loka vafranum alveg og
  opna hann upp á nýtt.
</p>
